import { Logo } from '@/components/icons'
import Link from 'next/link'
import React, { FC, PropsWithChildren } from 'react'

const FormLayout: FC<PropsWithChildren> = ({ children }) => {
	return (
		<div className="bg-gray-100 min-h-dvh flex flex-col">
			<div className="flex items-center justify-center h-20 bg-white">
				<Link href="/job-board">
					<Logo />
				</Link>
			</div>
			<div className="flex justify-center items-center mt-6 lg:mt-12 pb-4">{children}</div>
		</div>
	)
}

export default FormLayout
